<template>
  <el-dialog
    ref="applyingDialogRef"
    :title="$t('Fee.BeneficiaryAccountApplying')"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :lock-scroll="true"
    center
    :show-close="false"
  >
    <div class="step">
      <div class="step-title">{{ $t('Fee.BeneficiaryAccountApplyingStep[0]') }}</div>
      <el-form ref="accountUpdateDraft" label-position="right" label-width="120px" :disabled="true">
        <el-form-item :label="$t('Fee.BankNumber')" prop="bankNumber">
          <el-input v-model="accountUpdateDraft.BankBranchCode" maxlength="7"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Fee.Account')" prop="account">
          <el-input v-model="accountUpdateDraft.Account" maxlength="16"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Fee.AccountName')" prop="accountName">
          <el-input v-model="accountUpdateDraft.AccountName" maxlength="39"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 暫時性移除 -->
    <!-- <div class="step">
      <div class="step-title">{{ $t('Fee.BeneficiaryAccountApplyingStep[1]') }}</div>
      <div class="step-hint">{{ $t('Fee.BeneficiaryAccountApplyingStepHint[0]') }}</div>
      <div class="btn-wrap">
        <el-button
          size="mini"
          type="primary"
          @click="downloadAgreement"
        >
          {{ $t('Fee.DownloadAgreement') }}
        </el-button>
      </div>
    </div> -->
    <div class="step">
      <div class="step-title">{{ $t('Fee.BeneficiaryAccountApplyingStep[2]') }}</div>
      <div class="step-hint">{{ $t('Fee.BeneficiaryAccountApplyingStepHint[1]') }}</div>
      <div v-if="accountUpdateDraft?.CanWithdraw" class="step-hint">{{ $t('Fee.BeneficiaryAccountApplyingStepHint[2]') }}</div>
      <div v-if="accountUpdateDraft?.CanWithdraw" class="revert-btns">
        <el-button
          size="mini"
          type="primary"
          @click="revertApply"
        >
          {{ $t('Fee.CanRevertApply') }}
        </el-button>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        round
        @click="close"
      >
        {{ $t('General.Close') }}
      </el-button>
      <el-button
        v-if="isShowNextButton"
        type="primary"
        round
        @click="nextStep"
      >
        {{ $t('Fee.NextStep') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    dialogVisible: Boolean,
    isShowNextButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      accountUpdateDraft: state => state.fee.accountConfig?.AccountUpdateDraft || {}
    })
  },
  methods: {
    close () {
      this.$emit('close')
      const body = this.$refs.applyingDialogRef?.$el.querySelector('.el-dialog__body')
      if (body) body.scrollTop = 0
    },
    downloadAgreement () {
      const fileName = '智生活啟用設定增補協議書.pdf'
      const link = document.createElement('a')
      link.href = process.env.NODE_ENV === 'development' ? '/Agreement.pdf' : `${window.location.origin}/mgmt/Agreement.pdf`
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    nextStep () {
      this.$emit('nextStep')
      // 若開啟下個彈窗及關閉此彈窗同時進行，會發生 backdrop 閃一下的狀況
      this.$nextTick(() => { this.close() })
    },
    revertApply () {
      this.$confirm(
        `<div>${this.$t('Fee.CheckRevertApplyBody[0]')}</div><div>${this.$t('Fee.CheckRevertApplyBody[1]')}</div>`,
        this.$t('Fee.CheckRevertApplyTitle'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('Fee.ConfirmRevertApply'),
          cancelButtonText: this.$t('General.Cancel')
        }
      ).then(async () => {
        try {
          await apiBillserviceKGI.Config.WithdrawApply()
          this.close()
          this.$emit('update')
        } catch (e) {
          // 400030 不可撤回
          console.log(e)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  & > .step:not(:last-child) {
    margin-bottom: 20px;
  }
}
.step {
  padding: 20px 25px;
  background-color: $bgDark4;
  ::v-deep .el-form {
    padding-left: 10px;
    margin-top: 22px;
  }
  ::v-deep .el-form-item__label {
    margin-right: 0 !important;
    line-height: 40px !important;
  }
  ::v-deep .el-form-item__content {
    max-width: 450px;
  }
  ::v-deep .el-input input {
    cursor: text;
    border: unset;
    background-color: transparent;
    padding-left: unset;
  }
  .step-title {
    font-size: map-get($fontSize, large);
    font-weight: bold;
    color: $mainFontColor;
    margin-bottom: 15px;
  }
  .step-hint {
    color: $warnColor;
    padding-left: 20px;
    line-height: 20px;
  }
  .revert-btns {
    padding-left: 20px;
    margin-top: 15px;
  }
  .btn-wrap {
    display: flex;
    align-items: end;
    padding-left: 20px;
    margin-top: 15px;
    .preview {
      margin-right: 20px;
      img {
        cursor: pointer;
        width: 150px;
      }
    }
  }
}
</style>
